export default __webpack_public_path__ + "static/media/Social_notifications.4a792ca3.svg";